<template>
  <div :class="$style.formContainer">
    <LoginCard
      key="confirmation"
      class="email-sent-content"
      header="Admin Authenticator App Reset Request"
    >
      <h5 :class="$style.subheader">
        You have requested an Authenticator App reset.
      </h5>
      <ul :class="$style.directionsList">
        <li :class="$style.directions">
          A confirmation email has been sent (email address must be registered with JumpCloud).
        </li>
        <li :class="$style.directions">
          Please follow the instructions in the email to reset your authenticator app.
        </li>
        <li :class="$style.directions">
          Allow up to 10 minutes for the email to arrive in your inbox.
        </li>
      </ul>
      <LoginActionButton
        :action="goToLogin"
      >
        Return to Login
      </LoginActionButton>
    </LoginCard>
  </div>
</template>

<script>
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';

export default {
  name: 'RequestTOTPReset',

  components: {
    LoginActionButton,
    LoginCard,
  },

  methods: {
    goToLogin() {
      this.$router.push({ name: 'Admin Login' });
    },
  },
};
</script>

<style module>
@import '../css/login-components.css';

.directionsList {
  margin-top: 20px;
  text-align: left;
}

.directions {
  margin-bottom: 1.5em;
}

.fadeEnterActive {
  transition: opacity 0.35s 0.35s;
}

.fadeLeaveActive {
  transition: opacity 0.35s;
}

.fadeEnter,
.fadeLeaveTo {
  opacity: 0;
}
</style>
